import { Lookup } from "../oss/lookup.ts";
import { Repair } from "./Repair.ts";
import {
  type RepairLocationProfile,
  Ruleset,
  randomItemFromSelectOn,
} from "./Ruleset.ts";

export class RepairLocation {
  ruleset: Ruleset;
  data: RepairLocationProfile;

  constructor(ruleset: Ruleset, data: RepairLocationProfile) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get cost() {
    return this.data.costProperJob;
  }

  get selectOn() {
    return this.data.selectOn;
  }

  get repairs() {
    return Lookup.fromItems(
      this.data.repairs.map((data) => new Repair(this, data)),
    );
  }

  getRandomRepair() {
    return randomItemFromSelectOn(this.repairs.toArray());
  }
}
